import React from "react";

import { FormattedMessage } from "react-intl";
import CategoryFilterItem from "./CategoryFilterItem";
import { Category } from "shared/src/types/articlesearch/Category";
import { SearchQuery } from "shared/src/types/articlesearch/SearchResult";

const shortCategoryListSize = 4;

type Props = {
    categories: Category[];
    query: SearchQuery;
    queryLinkComponent: any;
};

type State = {
    shorter: boolean;
};

class ShortenedCategoryList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            shorter: true
        };
    }

    handleToggle(e: any) {
        e.preventDefault();
        this.setState({ shorter: !this.state.shorter });
    }

    renderListItem(partOfShortList: boolean, category: Category) {
        const className = "category-filter-item " + (partOfShortList ? "" : " long-list");
        return (
            <li className={className} key={category.urlCategoryPath}>
                <CategoryFilterItem
                    query={this.props.query}
                    categoryName={category.name}
                    categoryAmounts={category.amounts}
                    urlCategoryPath={category.urlCategoryPath}
                    queryLinkComponent={this.props.queryLinkComponent}
                />
            </li>
        );
    }

    renderToggle() {
        const remaining = this.props.categories.length - shortCategoryListSize;
        if (remaining <= 0) {
            return null;
        }
        let text;
        if (this.state.shorter) {
            text = (
                <span>
                    {remaining + " "}
                    <FormattedMessage id="EX_FILTER_PANEL_MORE_CATEGORIES" />
                </span>
            );
        } else {
            text = <FormattedMessage id="EX_FILTER_PANEL_LESS_CATEGORIES" />;
        }
        return (
            <li className="category-filter-item">
                <a className="more-categories" href="#" onClick={this.handleToggle.bind(this)}>
                    {text}
                </a>
            </li>
        );
    }

    render() {
        const shortList = this.props.categories.slice(0, shortCategoryListSize);
        const rest = this.props.categories.slice(shortCategoryListSize);
        const className = "second-level-categories " + (this.state.shorter ? "collapsed" : "");
        if (this.props.categories.length <= 0) {
            return null;
        } else {
            return (
                <ul className={className}>
                    {shortList.map(this.renderListItem.bind(this, true))}
                    {rest.map(this.renderListItem.bind(this, false))}
                    {this.renderToggle()}
                </ul>
            );
        }
    }
}

export default ShortenedCategoryList;
